module.exports = __webpack_public_path__ + "static/media/Privacy-policy-6495244-edited 12 May 2021.eda3e6ef.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Documents/Privacy-policy-6495244-edited 12 May 2021.pdf
// module id = 5313
// module chunks = 1